import { Post } from '../request'

export const createPaymentIntent = (totalAmount) => {
  return Post('/payment/create', {
    total_amount: totalAmount,
  })
}
